import { render } from "./MfaApproachingModal.vue?vue&type=template&id=6376d854"
import script from "./MfaApproachingModal.vue?vue&type=script&lang=js"
export * from "./MfaApproachingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__